import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const {
  GET_MONTH_END_ALERTS_COUNT_REQUEST,
  GET_MONTH_END_ALERTS_COUNT_SUCCESS,
  GET_MONTH_END_ALERTS_COUNT_FAILURE,
  GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS,
} = monthEndAlertConstants;

function* getMonthEndAlertCount(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(monthEndAlertsService.getMonthEndAlertCount, payload?.payload);
    if (response?.status === 200) {
      if (
        payload?.payload?.source === 'DASHBOARD' &&
        payload?.payload?.param?.timePeriod === 'THIS_MONTH'
      ) {
        yield put({ type: GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS, payload: response.data });
      } else {
        yield put({ type: GET_MONTH_END_ALERTS_COUNT_SUCCESS, payload: response.data });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MONTH_END_ALERTS_COUNT_FAILURE, payload: error });
  }
}

function* getMonthEndAlertCountSaga() {
  yield takeEvery(GET_MONTH_END_ALERTS_COUNT_REQUEST, getMonthEndAlertCount);
}

export default getMonthEndAlertCountSaga;
